import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import React from 'react';
import classes from './Intro.module.scss';

class Intro extends React.Component {
	render() {
		return (
			<div
				className={[classes.Overlay, this.props.closed && classes.hidden]
					.filter(Boolean)
					.join(' ')}
			>
				<div className={classes.Title}>
					Partageons plus de 25 ans
					<br /> d'une histoire unique.
				</div>

				<div className={classes.SecondaryTitle}>
					Le Groupe Duval vous invite à découvrir <br />
					ses meilleurs vœux pour l'année 2021.
				</div>

				<div
					onClick={this.props.onClose}
					className={[classes.Hovicon, classes.Effect].join(' ')}
				>
					<PlayArrowIcon />
				</div>
			</div>
		);
	}
}

export default Intro;
